module.exports = __webpack_public_path__ + "img/img-otp-02.png";